module.exports = __webpack_public_path__ + "static/icon_logo-b97d013a5db6e06c03ae962e7cfa8f5d.png";